"use client";

import { Card } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Brain, Users, GraduationCap, ClipboardCheck } from "lucide-react";
const services = [{
  id: 1,
  icon: Brain,
  title: "Applied Behavior Analysis (ABA) Therapy",
  description: "Evidence-based therapy tailored to each child's unique needs.",
  bullets: ["Individualized treatment plans", "Data-driven progress tracking", "Skills development across all domains"]
}, {
  id: 2,
  icon: Users,
  title: "In-Home & School-Based Support",
  description: "Comprehensive services in familiar environments.",
  bullets: ["Flexible scheduling to fit family routines", "Collaboration with educators and caregivers", "Consistent support across settings"]
}, {
  id: 3,
  icon: GraduationCap,
  title: "Parent and Caregiver Training",
  description: "Empowering families with practical strategies and knowledge.",
  bullets: ["One-on-one coaching sessions", "Bilingual (English/Spanish) support", "Ongoing guidance and resources"]
}, {
  id: 4,
  icon: ClipboardCheck,
  title: "Behavior Assessments & BCBA Clinical Supervision",
  description: "Professional evaluations and ongoing clinical oversight.",
  bullets: ["Comprehensive functional assessments", "Board Certified Behavior Analyst supervision", "Regular reviews and program adjustments"]
}];
export default function ServiceDetails() {
  const {
    ref: section1Ref,
    isVisible: section1Visible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: section2Ref,
    isVisible: section2Visible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: section3Ref,
    isVisible: section3Visible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: section4Ref,
    isVisible: section4Visible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const refs = [section1Ref, section2Ref, section3Ref, section4Ref];
  const visibleStates = [section1Visible, section2Visible, section3Visible, section4Visible];
  return <section id="service-details" className="py-16 lg:py-24 bg-background">
      <div className="container mx-auto px-4 max-w-6xl">
        <div className="space-y-12 lg:space-y-16">
          {services.map((service, i) => {
          const Icon = service.icon;
          const isVisible = visibleStates[i];
          return <div key={service.id} data-index={i} ref={refs[i] as React.RefObject<HTMLDivElement>} className={`transition-all duration-200 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-[10px]"}`}>
                <Card className="hover:shadow-medium hover:-translate-y-1 transition-all duration-200">
                  <div className="grid grid-cols-1 lg:grid-cols-[auto_1fr] gap-6 lg:gap-8 items-start">
                    {}
                    <div className="flex justify-center lg:justify-start">
                      <div className="w-16 h-16 lg:w-20 lg:h-20 bg-primary/10 rounded-[var(--radius-lg)] flex items-center justify-center">
                        <Icon className="w-8 h-8 lg:w-10 lg:h-10 text-primary" strokeWidth={1.5} />
                      </div>
                    </div>

                    {}
                    <div className="space-y-4">
                      <h3 className="font-display font-bold text-2xl lg:text-3xl text-foreground leading-tight">
                        {service.title}
                      </h3>
                      <p className="text-muted text-base lg:text-lg">
                        {service.description}
                      </p>
                      <ul className="space-y-2">
                        {service.bullets.map((bullet, bulletIndex) => <li key={bulletIndex} data-index={bulletIndex} className={`flex items-start gap-3 text-foreground/90 transition-all duration-200 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-[10px]"}`} style={{
                      transitionDelay: isVisible ? `${bulletIndex * 50}ms` : "0ms"
                    }}>
                            <span className="w-1.5 h-1.5 rounded-full bg-secondary mt-2 flex-shrink-0" />
                            <span className="text-base lg:text-lg">{bullet}</span>
                          </li>)}
                      </ul>
                    </div>
                  </div>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}